<template>
  <div class="container">
    <el-radio-group
      size="mini"
      v-if="channel == 'detail'"
      v-model="activeContent"
    >
      <el-radio-button :label="0">题目描述</el-radio-button>
      <el-radio-button :label="1">题目解析</el-radio-button>
    </el-radio-group>
    <el-radio-group size="mini" class="float mr-12 mb-12" v-model="activeName">
      <el-radio-button
        v-for="(language, index) in questionForm.languages"
        :key="index"
        :label="language.lang"
        >{{ language.label }}</el-radio-button
      >
    </el-radio-group>
    <div class="code-container">
      <div class="header-section"></div>
      <div class="body-section">
        <dir class="left-container">
          <span class="index-n">
            {{ questionForm.languages[activeIndex].title }}</span
          >
          <markdown-it
            class="main-content"
            :md="questionForm.languages[activeIndex].stem"
          ></markdown-it>
          <template v-if="questionForm.caseList.length">
            <div class="test-case-content">
              <div
                v-for="(item, index) in questionForm.caseList"
                :key="item.id"
              >
                <div v-if="item.display">
                  <div class="test-case-title">
                    测试用例 {{ index + 1 }}
                    <el-tooltip placement="right" v-show="!index">
                      <div slot="content">仅展示部分测试用例，用于自测验证</div>
                      <i class="el-icon-warning"></i>
                    </el-tooltip>
                  </div>
                  <div class="test-case-item">
                    <p class="title-text">输入：</p>
                    <div class="text-case-input">
                      {{ item.type == 1 ? item.input : getInput(item.input) }}
                    </div>
                    <p class="title-text">输出：</p>
                    <!-- <el-table
                      :data="item.output"
                      size="mini"
                      border
                      class="table-class"
                      v-if="languageType"
                    >
                      <div
                        v-for="(columnItem, columnIndex) in item.columnName"
                        :key="columnIndex"
                      >
                        <el-table-column
                          :prop="columnItem"
                          :label="columnItem"
                          width="80"
                        >
                        </el-table-column>
                      </div>
                    </el-table> -->
                    <div v-if="languageType" class="table-content">
                      <table border="1" cellspacing="0">
                        <thead>
                          <tr>
                            <th
                              v-for="(oItem, oIndex) in item.columnName"
                              :key="oIndex"
                              class="table-head"
                            >
                              {{ oItem }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(outItem, outIndex) in item.outputTarget"
                            :key="outIndex"
                          >
                            <td
                              class="table-td"
                              v-for="name in item.columnName"
                              :key="name"
                            >
                              {{ outItem[name] }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="text-case-input" v-else>{{ item.output }}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </dir>
        <dir class="right-container">
          <div class="coding-header">
            <el-select
              v-model="currentLanguage"
              class="w-200"
              size="mini"
              value-key="id"
              placeholder="请选择编程语言"
              @change="handleCodeLan"
            >
              <el-option
                v-for="(programming, index) in questionForm.programmingLanguage"
                :key="index"
                :label="programming.name"
                :value="programming"
              >
              </el-option>
            </el-select>
            <div class="coding-reset" @click="handleReset">重置</div>
          </div>
          <div :class="['coding-content', fold ? 'fold' : '']">
            <JOnlineCode
              class="code-coding"
              ref="CodeContainer"
              :language="getLanguage ? getLanguage : ''"
              :inputCode="initCode"
              @input="handleInputCode"
              v-if="getLanguage"
              :env="env"
              :urlReplace="urlReplace"
            />
            <div class="coding-operate">
              <div
                :class="['fold-content', fold ? 'active' : '']"
                @click="fold = !fold"
              >
                <i
                  :class="[fold ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
                ></i>
              </div>
              <div class="operate-container">
                <div class="operate-header">
                  <div class="operate-title">自测输入</div>
                  <div class="operate-parameter">
                    <div class="operate-parameter-text">
                      {{ casesSort ? "单变量" : "多变量" }}
                    </div>
                    <i
                      class="el-icon-sort"
                      style="cursor: pointer;"
                      @click="handleCasesSort"
                    ></i>
                  </div>
                  <el-button size="mini" @click="handleRunStart"
                    >自测运行</el-button
                  >
                </div>
                <div class="operate-main">
                  <el-input
                    v-if="casesSort"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="请输入测试用例"
                    v-model="selfTestInput"
                    @blur="caseIndex = -1"
                  >
                  </el-input>
                  <div class="operate-main-more" v-else>
                    <div
                      class="case-more-box"
                      v-for="(item, index) in selfTestInputMany"
                      :key="item.i_id"
                    >
                      <el-input
                        size="mini"
                        :autosize="{ minRows: 1, maxRows: 2 }"
                        type="textarea"
                        @blur="caseIndex = -1"
                        style="width:90%; margin-top:4px"
                        placeholder="请输入变量"
                        v-model="item.i_content"
                      >
                      </el-input>
                      <i
                        v-if="index > 1"
                        @click="handleCaseDelete(index)"
                        class="el-icon-delete case-delete"
                      ></i>
                    </div>
                    <div class="operate-main-more-add" @click="handleAddInput">
                      + 新增
                    </div>
                  </div>
                  <div
                    class="load-test-case"
                    v-if="questionForm.caseList.length"
                  >
                    <el-select
                      v-model="caseTargetIndex"
                      @change="handleLoadTestCase(caseTargetIndex)"
                      size="mini"
                      placeholder="请选择测试用例"
                    >
                      <el-option
                        v-for="(item, index) in questionForm.caseList"
                        :key="index"
                        :label="`测试用例${index + 1}`"
                        :value="index"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="operate-container">
                <div class="operate-header">
                  <div class="operate-title">
                    运行结果
                    <el-tooltip placement="right">
                      <div slot="content">
                        当运行测试用例时，运行结果处能反馈测试用例的运行结果（通过/不通过），若自主输入，则只会展示输出值或运行出错
                      </div>
                      <i class="el-icon-warning"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div class="operate-main result" v-loading="resetLoading">
                  <div v-if="output && output.time">
                    <div v-if="!output.msg">
                      <div class="row" v-if="!inputStatus">
                        <span class="title-class">结果:</span>
                        <span :class="output.pass ? 'success' : 'error'">
                          {{ output.pass ? "自测通过" : "自测不通过" }}
                        </span>
                      </div>
                      <div class="row">
                        <span class="title-class">运行时间:</span>
                        <span>{{ output.time }}</span>
                      </div>
                      <div class="row">
                        <span class="title-class">输出值：</span>
                        <table
                          border="1"
                          style="margin-top:10px"
                          v-if="languageType"
                        >
                          <thead>
                            <tr>
                              <th
                                class="table-head"
                                v-for="(item, index) in columnName"
                                :key="index"
                              >
                                {{ item }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(outItem, outIndex) in output.output"
                              :key="outIndex"
                            >
                              <td
                                class="table-td"
                                v-for="name in columnName"
                                :key="name"
                              >
                                {{ outItem[name] }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <span v-else>{{ output.data }}</span>
                      </div>
                    </div>
                    <div v-else>
                      <span class="row error"> 运行出错：</span>
                      <span class="row">{{ output.msg }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </dir>
      </div>
    </div>
    <div
      class="analysis-content"
      v-if="channel == 'detail' && activeContent == 1"
    >
      <div class="analysis-content-title">解析：</div>
      <markdown-it
        class="analysis-content-text"
        :md="questionForm.languages[activeIndex].analysis"
      ></markdown-it>
    </div>
    <el-dialog title="提示" :visible.sync="submitDisplay" width="30%">
      <span class="dialog-text"
        >提交成功，系统运行提交代码测试用例通过
        <span :class="['break', rightNum == 0 ? '' : 'green']">{{
          rightNum
        }}</span
        >个、未通过<span :class="['break', errorNum == 0 ? '' : 'red']">
          {{ errorNum }}</span
        >个，如需修改请调整代码后再次点击提交</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDisplay = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import codeService from "@/global/service/code";
// import questionServices from "../../../global/service/question";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import { JOnlineCode } from "jiker-online-code";
import common from "./common";
export default {
  mixins: [common],
  props: {
    questionForm: {
      default: () => {},
      type: Object
    },
    channel: {
      type: String
    }
  },
  components: {
    MarkdownIt,
    JOnlineCode
  },
  watch: {
    activeName(val) {
      this.activeIndex = this.questionForm.languages.findIndex(
        item => item.lang == val
      );
    },
    questionForm(val) {
      if (val && JSON.stringify(val) !== "{}") {
        this.example = this.deepCopy(val.example);
        this.program = this.deepCopy(val.program);
        this.casesSort = this.questionForm.caseList[0].type == 1 ? true : false;
        this.currentLanguage = this.questionForm.programmingLanguage[0];
        if (this.languageType) {
          this.questionForm.caseList.forEach(data => {
            data.output =
              typeof data.output == "string"
                ? JSON.parse(data.output)
                : data.output;
            if (this.currentLanguage.name == "Mysql 8") {
              data.columnName = Object.keys(data.output[0]);
              data.outputTarget = data.output;
              return;
            }
            const columnLength = data.output.rows[0].length - 1;
            var item = {};
            const outputList = [];
            data.output.rows.forEach(row => {
              row.forEach((rData, rIndex) => {
                data.output.metaData.forEach((meta, mIndex) => {
                  if (rIndex == mIndex) {
                    item[meta.name] = rData;
                  }
                });
                if (rIndex == columnLength) {
                  outputList.push(item);
                  item = {};
                }
              });
            });
            data.columnName = Object.keys(outputList[0]);
            data.outputTarget = outputList;
          });
        }
      }
    },
    activeContent(val) {
      this.inputContent =
        val == 0
          ? this.program[this.currentLanguage.name]
          : this.example[this.currentLanguage.name];

      this.initCode =
        val == 0
          ? this.program[this.currentLanguage.name]
          : this.example[this.currentLanguage.name];
    }
  },
  data() {
    return {
      key: 1,
      caseTargetIndex: null,
      activeName: "zh",
      activeContent: 0,
      activeIndex: 0,
      currentLanguage: "",
      isVertical: true,
      program: [],
      example: [],
      inputContent: null,
      initCode: null,
      env: process.env.NODE_ENV == "development" ? "vip" : "prod",
      fold: false,
      outputResultText: "",
      output: {
        pass: null,
        data: null,
        time: "",
        msg: null
      },
      urlReplace: "",
      submitLoading: false,
      selfTestInput: "",
      selfTestInputMany: [
        { i_id: 1, i_content: "" },
        {
          i_id: 2,
          i_content: ""
        }
      ],
      codeStatus: false,
      caseIndex: -1,
      submitStatus: true,
      rightNum: 0,
      errorNum: 0,
      submitDisplay: false,
      inputStatus: false,
      resetLoading: false,
      languageType: true,
      targetCode: {},
      casesSort: false,
      language_t: ["Mysql 8", "Oracle"]
    };
  },
  created() {
    this.getReady();
  },
  methods: {
    getReady() {
      this.currentLanguage = this.questionForm.programmingLanguage[0];
      this.example = this.deepCopy(this.questionForm.example);
      this.program = this.deepCopy(this.questionForm.program);
      this.activeContent = this.channel == "detail" ? 1 : 0;
      this.handleCodeLan();
      this.casesSort = this.questionForm.caseList[0].type == 1 ? true : false;
      this.languageType = this.language_t.includes(this.currentLanguage.name);
      if (this.languageType) {
        this.questionForm.caseList.forEach(data => {
          data.output =
            typeof data.output == "string"
              ? JSON.parse(data.output)
              : data.output;
          // if (this.currentLanguage.name == "Mysql 8") {
          data.columnName = Object.keys(data.output[0]);
          data.outputTarget = data.output;
          // return;
          // }
          // const columnLength = data.output.rows[0].length - 1;
          // var item = {};
          // const outputList = [];
          // data.output.rows.forEach(row => {
          //   row.forEach((rData, rIndex) => {
          //     data.output.metaData.forEach((meta, mIndex) => {
          //       if (rIndex == mIndex) {
          //         item[meta.name] = rData;
          //       }
          //     });
          //     if (rIndex == columnLength) {
          //       outputList.push(item);
          //       item = {};
          //     }
          //   });
          // });
          // data.columnName = Object.keys(outputList[0]);
          // data.outputTarget = outputList;
        });
      }
    },
    deepCopy(data) {
      if (typeof data !== "object" || data === null) {
        throw new TypeError("传入参数不是对象");
      }
      let newData = {};
      const dataKeys = Object.keys(data);
      dataKeys.forEach(value => {
        const currentDataValue = data[value];
        // 基本数据类型的值和函数直接赋值拷贝
        if (typeof currentDataValue !== "object" || currentDataValue === null) {
          newData[value] = currentDataValue;
        } else if (Array.isArray(currentDataValue)) {
          // 实现数组的深拷贝
          newData[value] = [...currentDataValue];
        } else if (currentDataValue instanceof Set) {
          // 实现set数据的深拷贝
          newData[value] = new Set([...currentDataValue]);
        } else if (currentDataValue instanceof Map) {
          // 实现map数据的深拷贝
          newData[value] = new Map([...currentDataValue]);
        } else {
          // 普通对象则递归赋值
          newData[value] = this.deepCopy(currentDataValue);
        }
      });
      return newData;
    },
    handleReset() {
      this.$refs.CodeContainer.resetCode();
    },
    handleInputCode(e) {
      this.inputContent = e;
      if (!this.inputContent) {
        return;
      }
      if (this.inputContent == this.targetCode[this.currentLanguage.name]) {
        this.$emit("questionStatus", this.targetCode);
        return;
      }
      this.$emit("questionStatus", "");
    },
    // 载入测试用例
    handleLoadTestCase(index) {
      this.caseIndex = index;
      this.casesSort = this.questionForm.caseList[index].type == 1;
      if (this.questionForm.caseList[index].type == 1) {
        this.selfTestInput = this.questionForm.caseList[index].input;
        return;
      }
      const targetInput = [];
      this.questionForm.caseList[index].input.map(data => {
        targetInput.push({ i_id: data.key, i_content: data.value });
      });
      this.selfTestInputMany = targetInput;
    },
    // 对象转数组
    objectToArray(obj) {
      if (obj.constructor !== Object) {
        return [];
      }
      const result = [];
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          result.push({
            key,
            value: obj[key]
          });
        }
      }
      return result;
    },
    handleCodeLan() {
      this.inputContent =
        this.activeContent == 0
          ? this.program[this.currentLanguage.name]
          : this.example[this.currentLanguage.name];
    },
    handleAddInput() {
      this.selfTestInputMany.push({
        i_id: this.selfTestInputMany.length + 1,
        i_content: ""
      });
    },
    // 自测运行
    handleRunStart() {
      if (!this.inputContent) {
        this.$message.error("请输入相关代码");
        return;
      }
      let inputValue = "";
      if (this.caseIndex == -1) {
        if (!this.casesSort) {
          const exist = this.selfTestInputMany.filter(data => {
            if (data.i_content == "") {
              return data;
            }
          });
          if (exist.length) {
            this.$message.error("请输入测试用例");
            return;
          }
          const targetInput = this.selfTestInputMany.map(data => {
            return data.i_content;
          });
          this.questionForm.caseList.forEach((item, index) => {
            if (item.type == 2) {
              const dd = item.input.map(data => {
                return data.value;
              });
              this.caseIndex =
                JSON.stringify(dd) == JSON.stringify(targetInput)
                  ? index
                  : this.caseIndex;
            }
          });
          if (this.caseIndex < 0) {
            inputValue = [{ input: targetInput }];
          } else {
            const caseData = this.questionForm.caseList[this.caseIndex];
            const targetInput = caseData.input.map(data => {
              return data.value;
            });
            inputValue = [{ input: targetInput, output: caseData.output }];
          }
        } else {
          if (!this.selfTestInput) {
            this.$message.error("请输入测试用例");
            return;
          }
          this.questionForm.caseList.forEach((data, index) => {
            if (data.type == 1 && data.input == this.selfTestInput) {
              this.caseIndex = index;
            }
          });
          const caseData = this.questionForm.caseList[this.caseIndex];
          inputValue =
            this.caseIndex < 0
              ? [{ input: this.selfTestInput }]
              : [{ input: caseData.input, output: caseData.output }];
        }
      } else {
        const caseData = this.questionForm.caseList[this.caseIndex];
        const targetInput = !this.casesSort
          ? caseData.input.map(data => {
              return data.value;
            })
          : caseData.input;
        inputValue = [{ input: targetInput, output: caseData.output }];
      }
      const params = {
        language: this.getLanguage,
        cases: inputValue,
        // variableType: this.casesSor/t ? "SINGLE" : "MULTIPLE",
        code: window.btoa(encodeURIComponent(this.inputContent))
      };
      this.submitLoading = true;
      this.resetLoading = true;
      codeService
        .questionCase(params)
        .then(res => {
          this.output.time = res.time_use + "ms";
          this.output.pass = res.pass;
          this.output.data = res.data;
          this.output.msg = res.msg;
          if (this.caseIndex >= 0) {
            this.questionForm.caseList[this.caseIndex].status = res.pass;
          }
          if (this.channel == "create") {
            if (res.pass) {
              const casePassStatus = this.questionForm.caseList.filter(
                data => data.status == true
              );
              if (casePassStatus.length == this.questionForm.caseList.length) {
                this.targetCode[this.currentLanguage.name] = this.inputContent;
                this.$emit("questionStatus", this.targetCode);
              }
            }
          }
          if (this.languageType && !this.output.msg) {
            // if (this.currentLanguage.name == "Oracle") {
            //   const columnLength = res.data.rows[0].length - 1;
            //   var item = {};
            //   const outputList = [];
            //   res.data.rows.forEach(row => {
            //     row.forEach((data, index) => {
            //       res.data.metaData.forEach((meta, mIndex) => {
            //         if (index == mIndex) {
            //           item[meta.name] = data;
            //         }
            //       });
            //       if (index == columnLength) {
            //         outputList.push(item);
            //         item = {};
            //       }
            //     });
            //   });
            //   this.output.output = outputList;
            //   this.columnName = Object.keys(outputList[0]);
            //   this.inputStatus = this.caseIndex == -1 ? true : false;
            //   return;
            // }
            this.columnName = Object.keys(res.data[0]);
            this.output.output = res.data;
          }
          this.inputStatus = this.caseIndex == -1 ? true : false;
        })
        .finally(() => {
          this.submitLoading = false;
          this.submitStatus = false;
          this.resetLoading = false;
        });
    },

    // 提交代码
    handleCodeSubmit() {
      if (!this.inputContent) {
        this.$message.error("请输入相关代码");
        return;
      }
      const caseList = [];
      this.questionForm.caseList.forEach(data => {
        caseList.push({
          input:
            data.type == 1
              ? data.input
              : data.input.map(item => {
                  return item.value;
                }),
          output: data.output
        });
      });
      this.submitLoading = true;
      const params = {
        language: this.getLanguage,
        cases: caseList,
        code: window.btoa(encodeURIComponent(this.inputContent)),
        type: 1
      };
      this.resetLoading = true;
      this.fold = false;
      this.rightNum = 0;
      this.errorNum = 0;
      codeService
        .questionCase(params)
        .then(res => {
          this.rightNum = res.pass_count;
          this.errorNum = res.fail_count;
          this.submitDisplay = true;
          if (this.rightNum == this.questionForm.caseList.length) {
            this.targetCode[this.currentLanguage.name] = this.inputContent;
            this.$emit("questionStatus", this.targetCode);
          }
        })
        .finally(() => {
          this.submitLoading = false;
          this.resetLoading = false;
        });
    },
    handleCaseDelete(index) {
      this.$confirm("是否删除该变量", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.selfTestInputMany.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleCasesSort() {
      this.casesSort = !this.casesSort;
      this.caseTargetIndex = null;
      this.caseIndex = -1;
      this.selfTestInput = null;
      this.selfTestInputMany = [
        { i_id: 1, i_content: "" },
        {
          i_id: 2,
          i_content: ""
        }
      ];
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.run-button {
  display: none !important;
}
.container {
  margin-bottom: 20px;
}
.float {
  float: right;
  clear: both;
}
.table-content {
  overflow-y: auto;
  padding: 4px;
}
.table-head {
  padding: 0 4px;
  text-align: center;
  font-weight: 500;
}
.table-td {
  padding: 2px 4px;
  text-align: center;
}
table,
td {
  border: 1px solid #000000;
  border-collapse: collapse;
}
.flex {
  display: flex;
  background: #fff;
  border: 1px solid #f5f5f5;
  .pd-16 {
    padding: 16px;
  }
  .left {
    flex: none;
    width: 300px;
    height: 498px;
    background: rgba(0, 0, 0, 2%);
    border-right: 1px solid #f5f5f5;
    &.flex.column {
      flex-direction: column;
    }
    .left-header {
      flex: none;
      font-size: 18px;
      font-weight: 500;
      background: #fff;
      border-bottom: 1px solid #f5f5f5;
    }
    .left-body {
      overflow-y: auto;
      .main-content {
        width: 100%;
        word-break: break-all;
        line-height: 22px;
        padding: 16px 24px;
      }
    }
  }
  .right {
    flex: 1;
    .right-header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;
      .set-screen {
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
      }
      .reset-btn {
        height: 25px;
        padding-top: 0;
        padding-bottom: 0;
      }
      .language-label {
        font-size: 16px;
        font-weight: 500;
        height: 25px;
        line-height: 25px;
      }
      /deep/.el-select {
        width: 110px;
      }
      /deep/.el-input {
        .el-input__suffix-inner {
          position: relative;
          display: inline-block;
        }
      }
      /deep/.el-input__inner {
        border: none;
        font-size: 16px;
        font-weight: 500;
        height: 25px;
        line-height: 25px;
      }

      /deep/.el-input__suffix {
        .el-icon-arrow-up {
          font-size: 18px;
          font-weight: 500;
        }
      }
    }
    .code-area {
      position: relative;
      height: 440px;
      text-align: left;
    }
  }
}
.dialog-text {
  .black {
    color: #333;
  }
  .red {
    color: #f56c6c;
  }
  .green {
    color: #67c23a;
  }
}

.case-more-box {
  position: relative;
  .case-delete {
    position: absolute;
    font-size: 14px;
    top: 34%;
    right: 2.5%;
    color: #1764e8;
    cursor: pointer;
    display: none;
  }
  &:hover {
    .case-delete {
      display: block;
    }
  }
}

.code-container {
  .title {
    background-color: #fffbe6;
    border-radius: 4px;
    font-size: 14px;
    padding: 8px 20px;
    width: 100%;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 20px;
    margin-bottom: 40px;
    i {
      color: #faad14;
    }
  }
  width: 100%;
  height: 100%;
  padding: 20px 10px 0 25px;
  background: #fff;
  // overflow-y: auto;
  .header-section {
    display: flex;
    label {
      padding: 4px 12px;
      width: fit-content;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #1764e8;
      line-height: 22px;
      border-radius: 15px;
      background-color: #1764e840;
    }
    .question-stack {
      font-family: PingFangSC-Medium, PingFang SC;
      margin-left: 8px;
      color: #36b355;
      background-color: #36b35540;
    }
  }
  .body-section {
    display: flex;
    width: 100%;
    .left-container {
      width: 35%;
      height: 435px;
      padding: 20px;
      background-color: #fafafa;
      overflow-y: auto;
      .index-n {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 2;
        margin-right: 5px;
      }
      .test-case-content {
        margin-top: 30px;
        .test-case-title {
          display: flex;
          align-items: center;
          margin: 10px 0 6px 0;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #333;
          i {
            margin-left: 6px;
            font-size: 14px;
          }
        }
        .test-case-item {
          padding: 6px;
          background-color: #fff;
          p {
            font-size: 15px;
            // margin-block: 4px;
            font-weight: bolder;
            margin: 4px 0;
          }
          .content-text {
            padding-left: 20px;
          }
        }
      }
    }
    .right-container {
      position: relative;
      padding-left: 30px;
      // padding-top: 10px;
      width: 65%;
      .coding-header {
        padding-left: 10px;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        border: 1px solid #f1f1f1;
        border-radius: 4px;
        // margin-bottom: 20px;
        .coding-language-select {
          width: 150px;
        }
        .coding-reset {
          margin-left: 15px;
          font-size: 14px;
          cursor: pointer;
          color: #666;
          &:hover {
            color: #409eff;
          }
        }
      }
      .fold-content {
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-10px);
        padding-top: 2px;
        width: 20px;
        height: 20px;
        background: #fff;
        border-radius: 50%;
        text-align: center;
        z-index: 2;
        cursor: pointer;
        box-shadow: 0px 2px 10px -2px #a9a9a9;
        &.active {
          padding-top: 0px;
        }
      }
      .coding-content {
        &.fold {
          .code-coding {
            height: 345px;
          }
          .coding-operate {
            height: 40px;
            .operate-container {
              height: 40px;
              overflow: hidden;
            }
          }
        }
        .code-coding {
          height: 220px;
          transition: height 0.5s ease-in-out;
        }
        /deep/.header-dark {
          display: none;
        }
        /deep/.text-container,
        /deep/.table-container {
          display: none;
        }
        /deep/.code-mirror {
          width: 100% !important;
        }
        .coding-operate {
          position: relative;
          width: 100%;
          height: 165px;
          display: flex;
          align-items: flex-start;
          transition: height 0.5s ease-in-out;
          .operate-container {
            width: 50%;
            height: 100%;
            transition: height 0.5s ease-in-out;
            .operate-header {
              height: 40px;
              padding: 4px 10px 4px 10px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              border: 1px solid #f2f2f2;
              .operate-parameter {
                display: flex;
                font-size: 12px;
                width: 100px;
                align-items: center;
                margin-right: 28px;
                .operate-parameter-text {
                  color: #409eff;
                  width: 40px;
                }
                i {
                  transform: rotate(90deg);
                }
              }
              .operate-title {
                width: 50%;
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #333;
                font-family: PingFangSC-Regular, PingFang SC;
                i {
                  margin-left: 6px;
                  font-size: 14px;
                }
              }
              .ant-btn {
                padding: 1px 10px;
              }
            }
            .operate-main {
              height: 135px;
              overflow-y: auto;
              border: 1px solid #f2f2f2;
              &.result {
                padding: 10px 15px;
                // padding-right: 10px;
                /deep/.header-light {
                  display: none;
                }
                /deep/.code-mirror {
                  display: none;
                }
                /deep/.table-container,
                /deep/.text-container {
                  margin-top: 4px;
                  width: 100% !important;
                  display: block;
                }
                ::-webkit-scrollbar-thumb {
                  background-color: #c1c1c1;
                }
                ::-webkit-scrollbar-track {
                  background: #f1f1f1;
                }
                #code-component {
                  height: auto;
                }
              }
              /deep/.el-textarea__inner {
                border: none;
                box-shadow: none;
                resize: none;
              }
              .load-test-case {
                padding: 4px 10px;
                display: flex;
                flex-wrap: nowrap;
                overflow-x: auto;
                span {
                  display: inline-block;
                  margin: 0 6px 4px 0;
                  font-size: 12px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  color: #409eff;
                  cursor: pointer;
                  flex: none;
                }
              }
              .row {
                display: inline-block;
                width: 100%;
                margin-bottom: 4px;
              }
              span {
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                &.title {
                  color: #555;
                }
                &.success {
                  font-family: PingFangSC-Medium, PingFang SC;
                  color: #67c23a;
                }
                &.error {
                  font-family: PingFangSC-Medium, PingFang SC;
                  color: #f56c6c;
                }
              }
            }
            .operate-main-more {
              height: 70%;
              // text-align: center;
              margin-left: 10px;
              overflow-y: auto;
              padding-top: 4px;
              .operate-main-more-add {
                margin: 0 auto;
                margin-top: 4px;
                font-size: 12px;
                width: 40px;
                cursor: pointer;
              }
              /deep/.el-textarea__inner {
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                box-shadow: none;
                resize: none;
              }
            }
          }
        }
      }
    }
  }
}
.table-class {
  margin: 10px 0;
  /deep/.el-table_1_column_2 {
    padding: 0 !important;
  }
}
.text-case-input {
  font-size: 14px;
  padding: 0 4px;
  word-wrap: break-word;
}
.analysis-content {
  margin: 10px 10px 0px 22px;
  padding: 10px;
  background-color: #fafafa;
  .analysis-content-title {
    font-weight: bolder;
    font-size: 16px;
    margin-bottom: 4px;
  }
  .analysis-content-text {
    font-size: 14px;
    text-indent: 28px;
    word-wrap: break-word;
  }
}
</style>
